import { create } from "@/api/launcherApp/signup"
import type { TApiSignupCreateParams, TApiSignupCreateResponse } from "@/api/launcherApp/signup/schema"

export async function actionCreateSignup(params: TApiSignupCreateParams): Promise<{ success: boolean; data?: TApiSignupCreateResponse }> {
  try {
    const result = await create(params)
    return { success: true, data: result }
  } catch (error) {
    console.error(error)
    return { success: false }
  }
}
